const isProduction = process.env.NODE_ENV === "production";
const clientId = process.env.REACT_APP_AAD_CLIENT_ID || (!isProduction ? "c8caa6c4-6393-4f90-a43b-6b3f619add27" : "");
const tenantId = process.env.REACT_APP_AAD_TENANT_ID || (!isProduction ? "05e4f087-3719-4046-8fa3-286b1f5110f2" : "");

if (!clientId || !tenantId) {
  throw new Error("Faltan REACT_APP_AAD_CLIENT_ID o REACT_APP_AAD_TENANT_ID en la configuración del entorno.");
}

export const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || (!isProduction ? "http://localhost:3001" : "")).replace(/\/$/, "");
export const apiScope = process.env.REACT_APP_API_SCOPE || "";

if (!apiBaseUrl) {
  throw new Error("Falta REACT_APP_API_BASE_URL en la configuración del entorno.");
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["User.Read", ...(apiScope ? [apiScope] : [])]
};

export const apiRequest = {
  scopes: apiScope ? [apiScope] : ["User.Read"]
};
